/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_TaglineInputs */

const en_service_legaroo_landing_tagline = /** @type {(inputs: Service_Legaroo_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Resources & Support Services`)
};

const fr_service_legaroo_landing_tagline = /** @type {(inputs: Service_Legaroo_Landing_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources juridiques et services de soutien`)
};

/**
* | output |
* | --- |
* | "Legal Resources & Support Services" |
*
* @param {Service_Legaroo_Landing_TaglineInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_tagline = /** @type {((inputs?: Service_Legaroo_Landing_TaglineInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_TaglineInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_tagline(inputs)
	return fr_service_legaroo_landing_tagline(inputs)
});